export default function print(action, props) {
  action({
    progress: false,
    buff: true,
    ...props
  })
    .then(res => {
      if (!res) return;
      const disposition = res.headers.get('Content-Disposition');
      let filename = 'document.xlsx'; 
      if (disposition) {
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utf8Match && utf8Match[1]) {
          filename = decodeURIComponent(utf8Match[1]);
        } else {
          const classicMatch = disposition.match(/filename="?([^";]+)"?/i);
          if (classicMatch && classicMatch[1]) {
            filename = classicMatch[1];
          }
        }
      }
      res.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      })
    })
}